<template>
  <section v-if="enabled && tools.length" class="mt-10" data-testid="top-products-ranking-dashboard-block">
    <h2>{{ t('ProductTop100Ranking.dashboard.title', { year: guideYear(now ?? new Date()) }) }}</h2>
    <div class="mt-5 overflow-hidden rounded-2xl border border-main bg-surface">
      <div class="flex flex-col divide-y divide-subtle">
        <TopProductsRankingDashboardCard v-for="tool in tools" :key="tool.id" :tool="tool" />
      </div>
      <TopProductsRankingCountdownBanner :now="now" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { FEATURE_FLAG } from '@/composables/featureFlagCatalog'
import { useFeatureFlag } from '@/composables/useFeatureFlag'
import { useReviewsProductsQuery } from '@/gql/reviews'

import { guideYear } from './collectionDeadline'
import TopProductsRankingCountdownBanner from './TopProductsRankingCountdownBanner.vue'
import TopProductsRankingDashboardCard from './TopProductsRankingDashboardCard.vue'
import type { TopProductsRankingDashboardTool } from './types'

defineProps<{ now?: Date }>()

const { t } = useI18n()
const { enabled } = useFeatureFlag(FEATURE_FLAG.REVIEWS_PRODUCTS.TOP_PRODUCTS_RANKING_RELEASE)
const { result } = useReviewsProductsQuery({ clientId: 'reviews', fetchPolicy: 'cache-and-network', nextFetchPolicy: 'cache-first' })

const tools = computed<TopProductsRankingDashboardTool[]>(() =>
  (result.value?.manage?.products ?? []).map((product) => ({
    id: product.id,
    title: product.title,
    slug: product.slug,
  })),
)
</script>
